// @flow
import {createAction} from 'redux-actions';

export const clearSessionAction = createAction('CLEAR_SESSION');

export const clearSession = () => {
    return clearSessionAction();
};
